module.exports = __webpack_public_path__ + "img/sejong_gallery1.59a6aaab.jpg";